import { Navigate } from 'react-router-dom';

import { useModules, type ModuleName } from '@/hooks/useModules';
import { useAuth } from '@/lib/auth';

interface ModuleGuardProps {
  module: ModuleName;
  allowedRoles?: string[];
  children: React.ReactNode;
}

export function ModuleGuard({ module, allowedRoles, children }: ModuleGuardProps) {
  const modules = useModules();
  const { user } = useAuth();

  if (!modules[module]) {
    return <Navigate to="/dashboard/module-unavailable" replace />;
  }

  if (allowedRoles && allowedRoles.length > 0 && user) {
    if (!user.isPlatformAdmin && !allowedRoles.includes(user.role)) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return <>{children}</>;
}
